<template>
  <div class="h-dialogContainer h-track-tabPage">
    <div class="row"></div>
    <form id="editLicenseDialog">
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit">{{$t('NSMF.instanceSliceProfileName')}} :</div>
          <ejs-textbox v-model="name" disabled="false"></ejs-textbox>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit">{{$t('NSMF.maxNumberofUEs')}} :</div>
          <ejs-textbox name="maxNumberofUEsCheck" v-model="maxNumberofUEs"></ejs-textbox>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit">{{$t('NSMF.caps')}} :</div>
          <ejs-textbox name="capsCheck" v-model="caps"></ejs-textbox>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit">{{$t('NSMF.gbps')}} :</div>
          <ejs-textbox name="gbpsCheck" v-model="gbps"></ejs-textbox>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit">{{$t('NSMF.gnbNum')}} :</div>
          <ejs-textbox name="gnbNumCheck" v-model="gnbNum"></ejs-textbox>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { EventBus } from "../../../../plugins/eventBus";
import { FormValidator } from "@syncfusion/ej2-vue-inputs";

export default {
  name: "EditLicenseDialog",
  components: {},
  data() {
    return {
      maxNumberofUEs: "",
      caps: "",
      gbps: "",
      gnbNum: "",
      name: "",
      sliceNum: "",
      locale: localStorage.getItem("locale"),
      dataSource: [],
      formObj: "",
      validationOption: {
        customPlacement(inputElement, errorElement) {
          errorElement.style.float = "left";
          inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {
          maxNumberofUEsCheck: {
            regex: ["^\\d*$", `${this.$t("Topo.invalidInt")}`]
          },
          capsCheck: {
            regex: ["^\\d*$", `${this.$t("Topo.invalidInt")}`]
          },
          gbpsCheck: {
            regex: ["^\\d*$", `${this.$t("Topo.invalidInt")}`]
          },
          gnbNumCheck: {
            regex: ["^\\d*$", `${this.$t("Topo.invalidInt")}`]
          }
        }
      }
    };
  },
  methods: {
    clear() {
      this.name = "";
      this.sliceNum = "";
      this.maxNumberofUEs = "";
      this.gnbNum = "";
      this.caps = "";
      this.gbps = "";
    },

    loadNeForm(checkedData) {
      this.name = checkedData.name;
      this.$axios
        .post(`/lte/ems/networkSlice/qryControl`, { id: checkedData.id })
        .then(response => {
          console.log("response==", response);
          if (
            response &&
            response.status === 200 &&
            response.data.errorCode === "SUCCESS"
          ) {
            this.dataSource = response.data.resultVal;
            let dataValue = response.data.resultVal;
            for (let i = 0; i < dataValue.length; i++) {
              if ("CAPS" == dataValue[i].control) {
                this.caps = dataValue[i].controlValue;
              }
              if ("MAX_NUMBER_OF_UE" == dataValue[i].control) {
                this.maxNumberofUEs = dataValue[i].controlValue;
              }
              if ("THROUGH_PUT" == dataValue[i].control) {
                this.gbps = dataValue[i].controlValue;
              }
              if ("NUMBER_OF_STATION" == dataValue[i].control) {
                this.gnbNum = dataValue[i].controlValue;
              }
            }
          } else {
            EventBus.$emit("toast", {
              type: "error",
              content: response.data.errorString
            });
          }
        });
      try {
        this.bindValidate();
      } catch (e) {
        console.log(e);
      }
    },
    getFormData() {
      if (!this.validate()) {
        return false;
      }
      for (let i = 0; i < this.dataSource.length; i++) {
        if ("CAPS" == this.dataSource[i].control) {
          if ("" == this.caps) {
            this.caps = 0;
          }
          this.dataSource[i].controlValue = this.caps;
        }
        if ("MAX_NUMBER_OF_UE" == this.dataSource[i].control) {
          if ("" == this.maxNumberofUEs) {
            this.maxNumberofUEs = 0;
          }
          this.dataSource[i].controlValue = this.maxNumberofUEs;
        }
        if ("THROUGH_PUT" == this.dataSource[i].control) {
          if ("" == this.gbps) {
            this.gbps = 0;
          }
          this.dataSource[i].controlValue = this.gbps;
        }
        if ("NUMBER_OF_STATION" == this.dataSource[i].control) {
          if ("" == this.gnbNum) {
            this.gnbNum = 0;
          }
          this.dataSource[i].controlValue = this.gnbNum;
        }
      }
      const sendData = this.dataSource;
      return sendData;
    },
    bindValidate() {
      this.formObj = new FormValidator(
        "#editLicenseDialog",
        this.validationOption
      );
    },
    validate() {
      const formStatus = this.formObj.validate();
      return formStatus;
    }
  },
  mounted() {
    this.bindValidate();
  }
};
</script>
